/** Implement actions related to user switching top-level search tabs such as "All Calls", "My Calls", etc.
 */
import alt from 'components/Dispatcher';

class SearchTabActions {
  constructor() {
    this.generateActions('switchWithMyCalls');
  }
}

export default alt.createActions(SearchTabActions);
